import { Component } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { CollaboratorSuggestion } from '@services/exfinder/exfinder.service';

@Component({
  selector: 'app-suggest-collab-modal',
  templateUrl: './suggest-collab-modal.component.html',
  styleUrls: ['./suggest-collab-modal.component.scss'],
})
export class SuggestCollabModalComponent {
  public idea: Idea;
  public session: Session;
  public suggestions: CollaboratorSuggestion[];

  constructor(
    private bus: BusService,
    private events: EventsService,
    private activeModal: NgbActiveModal,
  ) {}

  dismiss() {
    this.activeModal.close();
  }

  openIdeaModal(idea: Idea) {
    this.bus.publish(
      this.events.requested.data.session.idea.singleWithSession,
      idea._id,
      this.session._id,
    );
  }

  add(suggestion: CollaboratorSuggestion) {
    (suggestion as any).added = true;

    const payload = { participant_id: suggestion.participant._id }; // somehow that is what the API expects
    this.bus.publish(
      this.events.requested.action.session.idea.addCollaborator,
      payload,
      this.idea,
      this.session,
    );

    this.bus.publish(
      this.events.requested.action.tracking.track,
      this.session,
      'idea',
      'addCollaborator',
      this.idea._id,
    );
  }
}
